/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reset': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M25 5C14.352 5 5.633 13.379 5.055 23.89a2.005 2.005 0 00.894 1.805 2.005 2.005 0 002.012.11 1.995 1.995 0 001.086-1.696C9.512 15.676 16.44 9 25 9c4.586 0 8.7 1.926 11.61 5H34a1.988 1.988 0 00-1.754.992 1.982 1.982 0 000 2.016A1.988 1.988 0 0034 18h6.262c.226.04.457.04.687 0H44V8a2 2 0 10-4 0v3.777C36.332 7.621 30.965 5 25 5zm18.031 18.973a1.995 1.995 0 00-2.078 1.918C40.488 34.324 33.56 41 25 41c-4.586 0-8.695-1.926-11.61-5H16a1.988 1.988 0 001.754-.992 1.982 1.982 0 000-2.016A1.988 1.988 0 0016 32H9.719a2.147 2.147 0 00-.633 0H6v10c-.012.723.367 1.39.992 1.754a1.982 1.982 0 002.016 0A1.988 1.988 0 0010 42v-3.777C13.668 42.379 19.035 45 25 45c10.648 0 19.367-8.379 19.945-18.89a1.996 1.996 0 00-1.914-2.137z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/reset.js